"use strict";
var TextareaAutosize_1 = require("./TextareaAutosize");
module.exports = TextareaAutosize_1.TextareaAutosize;
